import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import GroupVisitForm from './GroupVisitForm';

export type NewVisitEntryVariant = 'landing' | 'dialogOnly';

export interface NewVisitProps {
  entryVariant?: NewVisitEntryVariant;
  onEntryClose?: () => void;
}

const NewVisit: React.FC<NewVisitProps> = ({ entryVariant = 'landing', onEntryClose }) => {
  const navigate = useNavigate();
  const { provider } = useAuth();
  const isDialogOnly = entryVariant === 'dialogOnly';
  const [openForm, setOpenForm] = useState(isDialogOnly);

  const handleCreateVisit = () => {
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    onEntryClose?.();
  };

  const landingSection = !isDialogOnly ? (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: 4,
        backgroundColor: '#ffffff',
        minHeight: 'calc(100vh - 64px)',
      }}
    >
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 4 }}>
          <img src="/logo_black.png" alt="EasyIP Logo" style={{ height: '120px' }} />
        </Box>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={handleCreateVisit}
          sx={{
            backgroundColor: '#2D4B73',
            color: '#ffffff',
            padding: '16px 48px',
            fontSize: '1.2rem',
            fontWeight: 600,
            borderRadius: 2,
            textTransform: 'none',
            boxShadow: '0 4px 14px 0 rgba(45, 75, 115, 0.4)',
            '&:hover': {
              backgroundColor: '#1E3452',
              boxShadow: '0 6px 20px 0 rgba(45, 75, 115, 0.5)',
            },
          }}
        >
          Create Visit
        </Button>
      </Box>
      <Box sx={{ mb: 4 }}>
        <Typography variant="body2" sx={{ color: '#666666', textAlign: 'center', fontSize: '0.875rem' }}>
          Copyright © 2025-2026 DSP Care Solutions LLC, All Rights Reserved
        </Typography>
        <Typography variant="body2" sx={{ color: '#666666', textAlign: 'center', fontSize: '0.875rem', mt: 0.5 }}>
          EasyIP is a trademark of DSP Care Solutions LLC
        </Typography>
      </Box>
    </Box>
  ) : null;

  const pid = provider?.provider_id != null ? Number(provider.provider_id) : undefined;

  return (
    <>
      {landingSection}

      <GroupVisitForm
        open={openForm}
        onClose={handleCloseForm}
        onSaved={() => {
          setOpenForm(false);
          onEntryClose?.();
          navigate('/visits');
        }}
        fixedProviderId={pid}
        providers={[]}
        defaultProviderId={null}
        editingVisit={null}
      />
    </>
  );
};

export default NewVisit;
